export default {
	google: {
		maps: {
			api_key: 'AIzaSyD4G7sGZJPg4rXSKNJA8HJrmDGMV3J5OgE'
		}
	}
}